<template>
  <PrimeDatePicker
    v-model="values"
    class="w-full"
    @blur="blurEventHandler($event)"
    v-bind="$attrs"
    :disabled="loading || disabled"
    :showIcon="true"
    :invalid="hasErrors"
    :id="props.id"
    :placeholder="props.placeholder"
    :minDate="props.min"
    :maxDate="props.max"
    :selectionMode="'range'"
    mask="99/99/9999"
    dateFormat="dd/mm/yy"
  >
    <template #footer>
      <div class="flex flex-row items-center justify-center w-full gap-2">
        <PrimeButton
          label="Clear"
          icon="pi pi-times"
          severity="secondary"
          :disabled="!values || values?.length === 0"
          @click="
            () => {
              values = [];
            }
          "
        />
      </div>
    </template>
  </PrimeDatePicker>
</template>

<script setup lang="ts">
import dayjs from "dayjs";
import {
  type IInputEvent,
  type IChangeEvent,
  type IBlurEvent,
} from "~/scad-shared/types/interfaces";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    error?: string;
    loading?: boolean;
    id?: string;
    placeholder?: string;
    min?: Date;
    max?: Date;
    context?: Indexable;
  }>(),
  {
    disabled: false,
    context: () => ({}),
    loading: false,
  }
);

const value = defineModel<any>("value");
const values = defineModel<any[]>("values");

watch(
  values,
  (newValue) => {
    if (
      newValue?.length === 2 &&
      newValue[0] !== null &&
      newValue[1] !== null
    ) {
      value.value = [
        dayjs(newValue[0]).format("YYYY-MM-DD"),
        dayjs(newValue[1]).format("YYYY-MM-DD"),
      ];
      changeEventHandler({ value: newValue });
      return;
    }
    if (value.value !== undefined) {
      value.value = undefined;
      changeEventHandler({ value: undefined });
    }
  },
  {
    deep: true,
  }
);

watch(
  value,
  (newValue) => {
    if (newValue === undefined || newValue === null) {
      values.value = [];
    }
  },
  {
    deep: true,
  }
);

// Computed property to handle date parsing
const hasErrors: ComputedRef<boolean> = computed(() => {
  if (props.error && props.error !== "") {
    return true;
  }
  return false;
});

const emits = defineEmits<{
  change: [event: IInputEvent];
  input: [event: IChangeEvent];
  blur: [event: IBlurEvent];
}>();

function changeEventHandler($event: any) {
  //console.log('value changed:', $event)
  emits("change", { ...$event, value: value.value });
}
function inputEventHandler($event: any) {
  emits("input", { ...$event, value: value.value });
}
function blurEventHandler($event: any) {
  emits("blur", { ...$event, value: value.value });
}
</script>

<style scoped></style>
